import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { FiMatTabBookmarkLayoutComponent } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-bookmark-layout.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-mat-tab-group-bookmark-layout',
    template: `
        <mat-tab-group
            class="fi-bookmark-layout-tab-group"
            (selectedTabChange)="selectedIndexChange($event)"
            [mat-stretch-tabs]="false"
        >
            <ng-content></ng-content>
        </mat-tab-group>
    `,
    styleUrls: ['./fi-mat-tab-group-bookmark-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-mat-tab-group-bookmark-layout' },
    standalone: false,
})
export class FiMatTabGroupBookmarkLayoutComponent implements AfterViewInit, OnInit, OnDestroy {
    @Input() selectedTabIndex$: Observable<number> = new Observable<number>();
    @Output() selectedTabIndexChange = new EventEmitter<number>();
    @ViewChild(MatTabGroup) public tabGroup: MatTabGroup;
    @ContentChildren(FiMatTabBookmarkLayoutComponent)
    protected tabComponents: QueryList<FiMatTabBookmarkLayoutComponent>;

    private readonly tabOffset: number = -3;

    constructor(
        private renderer2: Renderer2,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.selectedTabIndex$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((selectedIndex: number) => {
            setTimeout(() => {
                this.tabGroup.selectedIndex = selectedIndex;
                this.cdr.markForCheck();
            });
        });
    }

    ngAfterViewInit() {
        const matTabsFromQueryList: MatTab[] = this.tabComponents.map(
            (tab: FiMatTabBookmarkLayoutComponent) => tab.matTab,
        );
        const list = new QueryList<MatTab>();
        list.reset(matTabsFromQueryList);
        this.tabGroup._allTabs = list;
        this.tabGroup.ngAfterContentInit();
        setTimeout(() => this.setTabsStyles());
    }

    private setTabsStyles() {
        Array.from(this.tabGroup._elementRef.nativeElement.querySelectorAll('.mat-mdc-tab')).forEach(
            (tab: HTMLElement, index: number) => {
                this.renderer2.setStyle(tab, 'z-index', this.tabComponents.length - (index + 1));
                if (index > 0) this.renderer2.setStyle(tab, 'transform', `translateX(${index * this.tabOffset}px)`);
            },
        );
    }

    selectedIndexChange($event: MatTabChangeEvent) {
        this.selectedTabIndexChange.emit($event.index);
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
